import { cubicBezier as e } from "./atoms-v2983.js";
const o = /* @__PURE__ */ e(0.42, 0, 1, 1), s = /* @__PURE__ */ e(0, 0, 0.58, 1), c = /* @__PURE__ */ e(0.42, 0, 0.58, 1);
export {
  o as easeIn,
  c as easeInOut,
  s as easeOut
};
